import routing from './application.routes';
import applications from './applications';
import info from './info';
import storyboard from './storyboard';
import style from './style';
import main from './main';
import greenBackground from './greenBackground';
import frame from './frame';
import preview from './preview';
import filter from './filter';
import result from './result';
import data from './data';
import share from './share';
import quantity from './quantity';
import end from './end';
import gallery from './gallery';
import { ApplicationFactory } from './application.factory';

import ngFileUpload from 'ng-file-upload'

export default angular.module('bfastCaptureManagerApp.application', ['ui.bootstrap-slider', ngFileUpload, applications, info, storyboard, style, main, greenBackground, frame, filter, preview, result, data, share, quantity, end, gallery])
  .config(routing)
  .factory('Application', ApplicationFactory)
  .run(function($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .filter('wellformed' , function(Langue){
    return function(input){
      //storyBoard
      if(input == 'main') return Langue.selectedLanguage.main
      if(input == 'data') return Langue.selectedLanguage.data
      if(input == 'greenBackground') return Langue.selectedLanguage.greenBackground
      if(input == 'frame') return Langue.selectedLanguage.frame
      if(input == 'preview') return Langue.selectedLanguage.preview
      if(input == 'result') return Langue.selectedLanguage.result
      if(input == 'filter') return Langue.selectedLanguage.filter
      if(input == 'share') return Langue.selectedLanguage.share
      if(input == 'quantity') return Langue.selectedLanguage.quantity
      if(input == 'end') return Langue.selectedLanguage.end

      //modes
      if(input == 'classique') return Langue.selectedLanguage.classique
      if(input == 'multipose') return Langue.selectedLanguage.multipose
      if(input == 'gif') return Langue.selectedLanguage.gif
      if(input == 'boomerang') return Langue.selectedLanguage.boomerang

      //roles
      if(input == 'admin') return Langue.selectedLanguage.admin
      if(input == 'user') return Langue.selectedLanguage.user

      //month
      if(input == 'January') return Langue.selectedLanguage.January
      if(input == 'February') return Langue.selectedLanguage.February
      if(input == 'March') return Langue.selectedLanguage.March
      if(input == 'April') return Langue.selectedLanguage.April
      if(input == 'May') return Langue.selectedLanguage.May
      if(input == 'June') return Langue.selectedLanguage.June
      if(input == 'July') return Langue.selectedLanguage.July
      if(input == 'August') return Langue.selectedLanguage.August
      if(input == 'September') return Langue.selectedLanguage.September
      if(input == 'October') return Langue.selectedLanguage.October
      if(input == 'November') return Langue.selectedLanguage.November
      if(input == 'December') return Langue.selectedLanguage.December
    }
  })
  .factory('Langue', function(){
    var Langue = {}


    Langue.changeLanguage = function(newLangue){
      Langue.selectedLanguage = Langue[newLangue]
    }
    
    Langue.Francais = {
      "main" : "Veille",
      "data" : 'Collecte',
      "greenBackground" : 'Fond vert',
      "frame" : 'Cadres',
      "preview" : 'Prévisualiation',
      "result" : 'Rendu',
      "filter" : 'Filtres',
      "share" : 'Partage',
      "quantity" : 'Impression',
      "end" : 'Fin',
      "classique" : 'Classique',
      "multipose" : 'Multipose',
      "gif" : 'GIF',
      "boomerang" : 'Boomerang',
      "admin" : 'Administrateur',
      "user" : 'Utilisateur',
      "January" : 'Janvier',
      "February" : 'Février',
      "March" : 'Mars',
      "April" : 'Avril',
      "May" : 'Mai',
      "June" : 'Juin',
      "July" : 'Juilliet',
      "August" : 'Aout',
      "September" : 'Septembre',
      "October" : 'Octobre',
      "November" : 'Novembre',
      "December" : 'Décembre'
    }

    Langue.Anglais = {
      "main" : "Main",
      "data" : 'Data',
      "greenBackground" : 'Green background',
      "frame" : 'Frames',
      "preview" : 'Preview',
      "result" : 'Result',
      "filter" : 'Filter',
      "share" : 'Share',
      "quantity" : 'Quantity',
      "end" : 'End',
      "classique" : 'Classic',
      "multipose" : 'Multipose',
      "gif" : 'GIF',
      "admin" : 'Administrator',
      "user" : 'User',
      "January" : 'January',
      "February" : 'February',
      "March" : 'March',
      "April" : 'April',
      "May" : 'May',
      "June" : 'June',
      "July" : 'July',
      "August" : 'August',
      "September" : 'September',
      "October" : 'October',
      "November" : 'November',
      "December" : 'December'
    }

    Langue.selectedLanguage = Langue.Francais
    // Langue.selectedLanguage = Langue.Anglais

    return Langue
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/application/index.js